"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesOverview = void 0;
var vue_1 = require("vue");
var Phase_1 = require("../Phase");
var constants = require("../constants");
exports.GamesOverview = vue_1.default.component('games-overview', {
    data: function () {
        return {
            constants: constants,
            serverId: '',
            games: {},
        };
    },
    mounted: function () {
        this.serverId = (new URL(location.href)).searchParams.get('serverId') || '';
        this.getGames();
    },
    methods: {
        getGames: function () {
            var vueApp = this;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/games?serverId=' + this.serverId);
            xhr.onerror = function () {
                alert('Error getting games data');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var result = xhr.response;
                    if (result instanceof Array) {
                        result.forEach(function (game) {
                            vueApp.getGame(game.id);
                        });
                    }
                    else {
                    }
                }
                else {
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        getGame: function (gameId) {
            var vueApp = this;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/game?id=' + gameId);
            xhr.onerror = function () {
                alert('Error getting game data');
            };
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var result = xhr.response;
                    if (result instanceof Object) {
                        vue_1.default.set(vueApp.games, gameId, result);
                    }
                    else {
                    }
                }
                else {
                }
            };
            xhr.responseType = 'json';
            xhr.send();
        },
        isGameRunning: function (gamePhase) {
            return (gamePhase === Phase_1.Phase.END) ? false : true;
        },
    },
    template: "\n        <div id=\"games-overview\">\n            <h1>{{ constants.APP_NAME }} \u2014 Games Overview</h1>\n            <p>The following games are available on this server:</p>\n            <ul>\n                <li v-for=\"game in games\">\n                    <a v-bind:href=\"'/game?id='+game.id\">{{game.id}}</a> \n                    with {{game.players.length}} player(s) : \n                    <span class=\"player_home_block nofloat\" >\n                        <span v-for=\"player in game.players\" class=\"player_name\" :class=\"'player_bg_color_'+ player.color\">\n                            <a :href=\"'/player?id=' + player.id + '&serverId=' + serverId\">{{player.name}}</a>\n                        </span>\n                        <span v-if=\"isGameRunning(game.phase)\">is running</span><span v-else>has ended</span>\n                    </span>\n                </li>\n            </ul>\n        </div>\n    ",
});
//# sourceMappingURL=GamesOverview.js.map